import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Button, Chip } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useOrdenCompraStore } from '../store/ordenCompraStore';

const estadoColors: Record<string, 'success' | 'warning' | 'error' | 'info' | 'default'> = {
  APR: 'success', PEN: 'warning', ANU: 'error', ATE: 'info', CER: 'default',
};
const estadoLabels: Record<string, string> = {
  APR: 'Aprobada', PEN: 'Pendiente', ANU: 'Anulada', ATE: 'Atendida', CER: 'Cerrada',
};

export const OrdenesCompraPage: React.FC = () => {
  const navigate = useNavigate();
  const { items, loading, fetchAll } = useOrdenCompraStore();

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const columns: GridColDef[] = [
    { field: 'numeroOrden', headerName: 'Numero', width: 120 },
    {
      field: 'fechaOrden', headerName: 'Fecha', width: 120,
      valueFormatter: (value: string) => {
        try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; }
      },
    },
    { field: 'proveedor', headerName: 'Proveedor', flex: 1, minWidth: 200, valueGetter: (value: any) => value?.razonSocial || '-' },
    {
      field: 'fechaEntrega', headerName: 'Fecha Entrega', width: 120,
      valueFormatter: (value: string) => {
        if (!value) return '-';
        try { return format(new Date(value), 'dd/MM/yyyy', { locale: es }); } catch { return value; }
      },
    },
    { field: 'total', headerName: 'Total', width: 120, type: 'number', valueFormatter: (value: number) => `S/ ${(value ?? 0).toFixed(2)}` },
    {
      field: 'estado', headerName: 'Estado', width: 120,
      renderCell: (params) => (
        <Chip label={estadoLabels[params.value] || params.value || '-'} color={estadoColors[params.value] || 'default'} size="small" />
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">Ordenes de Compra</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/compras/orden-compra/nueva')}>Nueva Orden</Button>
      </Box>
      <Paper sx={{ height: 600 }}>
        <DataGrid
          rows={items} columns={columns} getRowId={(row) => row.idOrdenCompra}
          loading={loading} pageSizeOptions={[10, 20, 50]}
          initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          onRowClick={(params) => navigate(`/compras/orden-compra/${params.row.idOrdenCompra}`)}
          sx={{ cursor: 'pointer', border: 'none' }} disableRowSelectionOnClick
        />
      </Paper>
    </Box>
  );
};
